import React, { useEffect, useState, useMemo } from "react";
import IndentCard from "./IndentCard";
import HeadTag from "./HeadTag";
import DataTable from "./DataTables/DataTable";
import api from "./Axios/api";
import Loader from "./common/Loader";
import { useSelector } from "react-redux";
const Home = () => {
  const user_branch = useSelector((state) => state.user.staff_FacLoc);
  const user_role = useSelector((state) => state.user.staff_name);
  const [data, setData] = useState([]);
  const [month, setMonth] = useState("");
  const [isloading, setIsLoading] = useState(false);
  const getIndentData = async () => {
      setIsLoading(true);
    await api
      .get(`/indent/get?fy=${fy}`)
      .then((res) => {
        const filterData =
          user_role === "Admin" || user_role === "Sameer Khan"
            ? res.data
            : res.data.filter((item) => item.indent_branch === user_branch);
            const sortedData = filterData.sort((a, b) => new Date(b.indent_date) - new Date(a.indent_date));
            setData(sortedData); setIsLoading(false);
      })
      .catch((err) => console.log(err));
  };

    const getFinancialYear = (value) => {
  if (!value) return "";
  const [y, m] = value.split("-").map(Number);
  return m >= 4 ? `${y}-${y + 1}` : `${y - 1}-${y}`;
};

const fy = useMemo(() => getFinancialYear(month), [month]);
  useEffect(() => {
  if (!fy) return;
    getIndentData();
}, [fy]);

   useEffect(() => {
     const now = new Date();
     const year = now.getFullYear();
     const monthNum = String(now.getMonth() + 1).padStart(2, "0");
     const currentMonth = `${year}-${monthNum}`;
     setMonth(currentMonth);
 
   }, []);

  return (
    <div className="flex-1 mt-5 w-full justify-center items-center ">
      <div className="flex w-full flex-col justify-center items-center">
        <div className="flex w-11/12 justify-between items-center flex-wrap">
          <IndentCard name="Total" count={21} color="#CAF4FF" />
          <IndentCard name="Progress" count={7} color="#FEFFD2" />
          <IndentCard name="Open" count={8} color="#95D2B3" />
          <IndentCard name="Closed" count={6} color="#FFC5C5" />
        </div>
         {user_role !== "PolyBond Audit" && (
        <>
                <input
            type="month"
            value={month} 
            onChange={(e) => setMonth(e.target.value)}
            className="w-[180px] text-base border rounded px-3 py-2"
          />
        <HeadTag
          tagName="Indent List"
          to="/indentForm"
          type="new"
          buttonName="Add Indent"
        />
        
        <div className=" w-11/12  my-2 rounded-md shadow bg-[#fdfdfd] ">
          {  isloading ? ( <Loader/>):(
            
          <DataTable data={data} setData={setData} fy ={fy} />
          )}
        </div>
        </>
         )}
      </div>
    </div>
  );
};

export default Home;
